/** Domestic quotes are not offered for New Zealand. */
export function isDomesticQuotesEnabled(regionCode: string): boolean {
  return regionCode !== 'NZ';
}
